import { render, staticRenderFns } from "./explain-results-aside.component.vue?vue&type=template&id=edeb16e4&scoped=true"
import script from "./explain-results-aside.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-aside.component.vue?vue&type=style&index=0&id=edeb16e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeb16e4",
  null
  
)

export default component.exports